import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import color from '../../constants/color';

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 34,
    height: 19,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: color.blue,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: color.blue,
      border: '6px solid #fff',
      height: 17,
    },
  },
  thumb: {
    width: 16,
    height: 15,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[200],
    opacity: 1,
    height: 16.6,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ ...props }) => (
  <Switch
    disableRipple
    {...props}
  />
));

interface Props {
  check: boolean;
  onClick: Function;
}

const CustomizedSwitches: React.FC<Props> = ({ check, onClick }) => {
  const handleChange = () => {
    onClick();
  };

  return (
    <FormControlLabel
        // @ts-ignore
      control={<IOSSwitch checked={check} onChange={handleChange} name="checkedB" />}
      label=""
    />
  );
};
export default CustomizedSwitches;
